import Rebase from 're-base';
import firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyDsZ5gbCAGS7E3sOQi-p3Tf3WlRKUaIs5A',
  authDomain: 'eaten-f92d5.firebaseapp.com',
  databaseURL: 'https://eaten-f92d5.firebaseio.com',
  projectId: 'eaten-f92d5',
  storageBucket: 'eaten-f92d5.appspot.com',
  messagingSenderId: '158790540447'
};

export const app = firebase.initializeApp(config);
export const base = Rebase.createClass(app.database());
export const ref = firebase.database().ref();
export const firebaseAuth = firebase.auth;

export default config;



// WEBPACK FOOTER //
// ./client/config.js